import PropTypes from 'prop-types';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';

const ACTION_CONFIG = {
  view: {
    icon: VisibilityOutlinedIcon,
    label: 'View',
    hover: {
      color: '#1565c0',
      borderColor: 'rgba(21, 101, 192, 0.35)',
      bgcolor: 'rgba(21, 101, 192, 0.06)'
    }
  },
  edit: {
    icon: EditOutlinedIcon,
    label: 'Edit',
    hover: {
      color: '#1f5b40',
      borderColor: 'rgba(31, 91, 64, 0.35)',
      bgcolor: 'rgba(31, 91, 64, 0.08)'
    }
  },
  delete: {
    icon: DeleteOutlineIcon,
    label: 'Delete',
    hover: {
      color: '#c62828',
      borderColor: 'rgba(198, 40, 40, 0.35)',
      bgcolor: 'rgba(198, 40, 40, 0.06)'
    }
  }
};

const baseSx = {
  width: 32,
  height: 32,
  borderRadius: 1.5,
  border: '1px solid rgba(31, 91, 64, 0.12)',
  bgcolor: '#fff',
  color: 'text.secondary',
  transition: 'all 0.15s ease',
  '& .MuiSvgIcon-root': { fontSize: '1rem' }
};

// ==============================|| TABLE ACTION BUTTON ||============================== //

export default function TableActionButton({
  action = 'edit',
  title,
  onClick,
  disabled = false,
  children,
  ...other
}) {
  const config = ACTION_CONFIG[action] || ACTION_CONFIG.edit;
  const Icon = config.icon;
  const label = title || config.label;

  return (
    <Tooltip title={label} arrow>
      <span>
        <IconButton
          size="small"
          onClick={onClick}
          disabled={disabled}
          aria-label={label}
          sx={{
            ...baseSx,
            '&:hover': config.hover
          }}
          {...other}
        >
          {children || <Icon />}
        </IconButton>
      </span>
    </Tooltip>
  );
}

TableActionButton.propTypes = {
  action: PropTypes.oneOf(['view', 'edit', 'delete']),
  title: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  children: PropTypes.node
};
